import { createMachine, assign } from "xstate";

import {
  leadFormMachineContext,
  leadFormMachineEvent,
  leadFormMachineState,
  LeadFormSteps,
  leadFormEvents,
} from "./types";

export const gtmEmailOnlyMachine = createMachine<
  leadFormMachineContext,
  leadFormMachineEvent,
  leadFormMachineState
>(
  {
    id: "gtmLeadForm",
    initial: LeadFormSteps.gtmInlineEmail,
    context: {} as leadFormMachineContext,
    states: {
      [LeadFormSteps.gtmInlineEmail]: {
        id: LeadFormSteps.gtmInlineEmail,
        on: {
          [leadFormEvents.submit]: {
            target: LeadFormSteps.createLead,
            actions: ["updateFields"],
          },
        },
      },
      [LeadFormSteps.createLead]: {
        invoke: {
          src: "createLeadMutation",
          onDone: [
            {
              target: LeadFormSteps.gtmSuccess,
            },
          ],
          onError: {
            target: LeadFormSteps.error,
          },
        },
      },
      [LeadFormSteps.createExistingLead]: {
        invoke: {
          src: "createLeadMutation",
          onDone: [
            {
              target: LeadFormSteps.gtmSuccess,
            },
          ],
          onError: LeadFormSteps.error,
        },
      },
      [LeadFormSteps.gtmSuccess]: {
        id: LeadFormSteps.gtmSuccess,
        type: "final",
      },
      [LeadFormSteps.error]: {},
    },
    on: {
      existingLead: { target: LeadFormSteps.gtmInlineEmail },
      [leadFormEvents.updateContext]: {
        actions: assign((ctx, evt) => ({
          ...ctx,
          ...evt.value,
        })),
        internal: true,
      },
    },
  },
  {
    actions: {
      updateFields: assign((_, event) => {
        if (event.type === leadFormEvents.submit) {
          return { ...event.value };
        }
        return {};
      }),
      clearContext: assign({
        salesSegment: undefined,
        leadToken: undefined,
        id: undefined,
        status: undefined,
        employeeCount: undefined,
        isEcomm: undefined,
        fundingSource: undefined,
        monthlySales: undefined,
      }),
    },
  },
);
